import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { DriverGroup } from './public-api';
import { messageSchema } from './schemas/message-schema';

export function putDriverGroups(driverGroup: Partial<DriverGroup>) {
  return fromFetch(
    new Request(
      fleetEnvironment.driverGroupsIdUrl(String(driverGroup.driverGroupId)),
      {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
        body: JSON.stringify(driverGroup),
      }
    )
  ).pipe(selectData(messageSchema));
}
